export const memberPhoto = (person) =>
  person?.photos?.find((photo) => photo.id === person.card_photo_id) || person?.photos?.[0];

export const cardPhotoCrop = (photo) => ({ x: 50, y: 50, zoom: 1, ...photo?.card_crop });

export const cardPhotoImage = (photo) => photo?.card_path
  ? { ...photo, path: photo.card_path, card_crop: null }
  : photo;

export const cardPhotoStyle = (photo) => {
  const { x, y, zoom } = cardPhotoCrop(photo);
  return { objectPosition: `${x}% ${y}%`, transformOrigin: `${x}% ${y}%`, transform: `scale(${zoom})` };
};
